import React from 'react'
import { Form } from 'semantic-ui-react'
import { StyledField } from './style'
import { DateInput } from 'semantic-ui-calendar-react'
import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'
import dayjs from 'dayjs'
import { useAuth } from '~/routes/components/AuthProvider'
import { FormFields } from '~/components/FormFields'
import FarmerGroupQuery from '~/QueryHooks/FarmerGroupsQuery'
import { formatNumber } from '~/utils/helpers'
import InfitiveScrollDropown from '~/components/InfitiveScrollDropown'
import { Farmer } from '~/api/services/individualFilters'
import { FarmerCreateOptionsType } from '~/api/services/farmers'

interface Props {
  farmersList: Farmer[]
  farmerOptions: FarmerCreateOptionsType
}

const SecondRow: React.FC<Props> = ({ farmersList, farmerOptions }) => {
  const { t } = useTranslation()
  const { control, setValue, getValues } = useFormContext()
  const { systemData: { languages, logged: { languageId } } } = useAuth()

  const {
    data: farmerGroupList,
    isLoading: isLoadingFarmerGrouplist
  } = FarmerGroupQuery.getFarmersList()

  const languageLocal = languages.find(language => language.id === languageId)
  const watchCancellationField = useWatch({ control, name: 'terminationDate' })
  const watchLastDeliveryDateField = useWatch({ control, name: 'lastDeliveryDate' })
  const watchParentId = useWatch({ control, name: 'parentId' })
  const watchFarmerType = useWatch({ control, name: 'farmerType' })

  const terminationDate = watchCancellationField?.includes('-') ? dayjs(watchCancellationField).format('DD.MM.YYYY') : watchCancellationField
  const lastDeliveryDate = watchLastDeliveryDateField?.includes('-') ? dayjs(watchLastDeliveryDateField).format('DD.MM.YYYY') : watchLastDeliveryDateField

  const handleKeyPress = (event) => {
    event.preventDefault();
  }

  return <>
    <FormFields.Select
      control={control}
      name={'farmerType'}
      label={t('Farmer type')}
      selectOnBlur={false}
      rules={{
        required: {
          value: true,
          message: t('Please select farmer type')
        }
      }}
      placeholder={t('Select farmer type')}
      options={farmerOptions?.farmerTypes?.map(farmerType => ({ value: farmerType.key, text: farmerType.label })) || []}
    />
    {(watchFarmerType === 'sub' || !!watchParentId) && <InfitiveScrollDropown
      control={control}
      selectOnBlur={false}
      name={'parentId'}
      label={t('Main farmer')}
      value={getValues('parentId')}
      rules={{
        required: {
          value: true,
          message: t('Please select main farmer')
        }
      }}
      setValue={setValue}
      placeholder={t('Select main farmer')}
      options={farmersList.map(farmer => ({ value: farmer.id, text: farmer.companyName })) || []}
    />}
    <FormFields.Select
      selectOnBlur={false}
      control={control}
      label={t('Farmer group')}
      name='farmerGroupId'
      placeholder={t('Select farmer group')}
      rules={{
        required: {
          value: true,
          message: t('Select farmer group')
        }
      }}
      loading={isLoadingFarmerGrouplist}
      options={farmerGroupList?.map(farmerGroup => ({
        value: farmerGroup.id,
        text: `${farmerGroup.name} (${formatNumber(farmerGroup.amountPercent)}%)`
      })) || []}
    />
    <StyledField>
      <label>{t('Cancellation date')}</label>
      <DateInput
        name='date'
        localization={languageLocal.code}
        pickerStyle={{ width: 100 }}
        placeholder={t('Date')}
        closeOnMouseLeave={false}
        clearable
        onKeyPress={handleKeyPress}
        dateFormat={'DD.MM.YYYY'}
        closable
        value={terminationDate || ''}
        iconPosition='left'
        onChange={(event, { name, value }) => setValue('terminationDate', value)}
      />
    </StyledField>
    <Form.Field style={{ marginBottom: 0 }}>
      <label>{t('Date of last delivery')}</label>
      <DateInput
        name='date'
        pickerStyle={{ width: 100 }}
        placeholder={t('Date')}
        clearable
        localization={languageLocal.code}
        onKeyPress={handleKeyPress}
        className={'datePicker'}
        closeOnMouseLeave={false}
        closable
        dateFormat={'DD.MM.YYYY'}
        value={lastDeliveryDate || ''}
        iconPosition='left'
        onChange={(event, { name, value }) => setValue('lastDeliveryDate', value)}
      />
    </Form.Field>
  </>
}
export default SecondRow